
import { Options, Vue } from 'vue-class-component'
import { PropSync, Prop } from 'vue-property-decorator'
import IconScanQR from '@/components/svg/IconScanQR.vue'
import IconRfid from '@/components/svg/IconRfid.vue'

@Options({
  components: {
    IconScanQR,
    IconRfid,
  },
  name: 'ScanMethodSelectionDialog',
})
export default class ScanMethodSelectionDialog extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @Prop({ type: String, required: true }) readonly actionType!: string
  @Prop({ type: String }) readonly barcodeId?: string

  get projectParam() {
    return this.$store.getters.projectParam
  }

  selectCamera() {
    this._isShow = false
    this.$router.push({
      name: this.getCameraRouteName(),
      params: {
        project: this.projectParam,
        barcodeId: this.barcodeId || this.$store.state.barcode.barcode?.id,
      },
    })
  }

  selectRfid() {
    this._isShow = false
    this.$router.push({
      name: this.getRfidRouteName(),
      params: {
        project: this.projectParam,
        barcodeId: this.barcodeId || this.$store.state.barcode.barcode?.id,
      },
    })
  }

  getCameraRouteName(): string {
    return this.actionType
  }

  getRfidRouteName(): string {
    // Map camera route names to RFID route names
    const routeMap: Record<string, string> = {
      pair: 'pair-rfid',
      'barcode-unpair-scan': 'barcode-unpair-scan-rfid',
      'bulk-recycle': 'bulk-recycle-rfid',
      'link_to-scan': 'link_to-scan-rfid',
      'be_linked-scan': 'be_linked-scan-rfid',
    }
    return routeMap[this.actionType] || `${this.actionType}-rfid`
  }
}
